<script>
  import { tempStore } from "../../../stores/temp.store";
  import { userStore } from "../../../stores/user.store";
  import { hooksStore } from "../../../stores/hooks.store";

  import Icon from "../../../components/Icon/Icon.svelte";
  import {
    sourceExists,
    nastavViditelnostVrstvy,
    zobrazDataNaMape,
    vygenerujIdZdroja,
    pointTo,
  } from "../../../helpers/map";
  import { vratVrstvyMapyPodlaTypu } from "../../../helpers/config";
  import { vratGeojsonData } from "../../../api/geojson";

  import { get as get_store } from "svelte/store";
  import { onDestroy } from "svelte";
  import get from "get-value";

  export let data;

  const temp = get_store(tempStore);
  let timeout = get(temp, "eventsTimeout", 0);
  const typ = data.destination;
  const id = data.id;
  const nazov = data.title;

  const source_id = typ && id ? vygenerujIdZdroja(typ, id) : false;

  let user = [];
  let unsubscribeUserStore = userStore.subscribe((store) => {
    user = get(store) || {};
  });

  onDestroy(unsubscribeUserStore);

  const mouseOver = function (event) {
    if (!typ || !id) {
      return false;
    }

    if (hooksStore.applyFilters("tableItemPoi_zrusHover", false, typ, id)) {
      return false;
    }

    if (!source_id) {
      return false;
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    let stav = get(user, "options.mapa.stav", false) || {};
    if (get(stav[source_id]) === undefined) {
      event.preventDefault();
      event.stopPropagation();

      timeout = setTimeout(() => {
        if (sourceExists(source_id) !== false) {
          nastavViditelnostVrstvy(typ, source_id, "visible");
        } else {
          // ak taky zdroj nemam, musim ho najprv vytvoritt
          zobrazDataNaMape(
            { id: id, typ: typ, hover: true, nazov: nazov },
            false
          );
        }
      }, 300);
    }
  };

  const mouseOut = function (event) {
    if (!typ || !id) {
      return false;
    }

    if (hooksStore.applyFilters("tableItemPoi_zrusHover", false, typ, id)) {
      return false;
    }

    if (!source_id) {
      return false;
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    let stav = get(user, "options.mapa.stav", false) || {};
    if (get(stav[source_id]) === undefined) {
      event.preventDefault();
      event.stopPropagation();

      // timeout = setTimeout(() => {
      if (sourceExists(source_id) !== false) {
        nastavViditelnostVrstvy(typ, source_id, "none");
      }
      // }, 300);
    }
  };

  async function onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    // event.target.removeEventListener("mouseover", mouseOver);
    // event.target.removeEventListener("mouseout", mouseOut);

    if (!source_id) {
      return false;
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    if (sourceExists(source_id) !== false) {
      const vrstvy = vratVrstvyMapyPodlaTypu(typ);
      let sourceData = await hooksStore.applyFilters(
        "zobrazDataNaMape_vratGeojsonData",
        false,
        typ,
        id
      );

      // z api vratim geojson data
      if (!sourceData) {
        sourceData = await vratGeojsonData(typ, id);
      }
      if (!sourceData) {
        return false;
      }

      nastavViditelnostVrstvy(typ, source_id, "visible");
      hooksStore.doAction(
        "ulozVrstvyDoStavu",
        { id: id, gistyp: typ, nazov: nazov },
        source_id,
        sourceData,
        vrstvy[0].typ_vrstvy
      );
      pointTo(sourceData, vrstvy[0].typ_vrstvy);
    } else {
      // ak taky zdroj nemam, musim ho najprv vytvoritt
      zobrazDataNaMape({ id: id, typ: typ, nazov: nazov });
    }
  }
</script>

{#if data.id}
  <div
    class="pin"
    on:mouseover={mouseOver}
    on:mouseout={mouseOut}
    on:click={onClick}
    on:focus={() => void 0}
    on:blur={() => void 0}
  >
    <Icon kod="030" />
  </div>
{/if}

<style lang="scss">
  .pin {
    cursor: pointer;
    text-align: center;
  }
</style>
